import React from 'react';

import BlankSlate from '../../common/BlankSlate/BlankSlate';
import ExternalLink from '../../common/Labels/ExternalLink';
import Image from '../../common/Image/Image';

import useJupyter from '../../../utils/hooks/use_jupyter';

import emptyStateRocketImage from '../../../assets/empty_state_rocket.png';

import useClientContext from '../../contexts/ClientData/ClientData';

const EmptyListGraphic = () => (
  <Image
    src={emptyStateRocketImage}
    className="opacity-80"
    style={{ maxWidth: 500 }}
    alt=""
  />
)

const EmptyListInfoSection = () => {
  const { jupyter } = useJupyter();
  const { isJupyterEnabled } = useClientContext();

  return (
    <div className="flex justify-center items-center">
      <ExternalLink
        openInNewTab
        to="https://docs.wallaroo.ai/"
        size="lg"
      >
      Quickstart guide
      </ExternalLink>
      <span className="mx-2">&middot;</span>
      <ExternalLink
        openInNewTab
        to={jupyter ? jupyter.url : '/'}
        size="lg"
        color={isJupyterEnabled ? 'brand' : 'gray-400'}
        isJupyterEnabled={isJupyterEnabled}
      >
      Launch Jupyter Notebook
      </ExternalLink>
    </div>
  )
}

export const ModelListBlankSlate = () => (
  <BlankSlate
    className="p-4"
    mainText="Upload a model from Jupyter to get started"
    Graphic={EmptyListGraphic}
    CTAInfo={EmptyListInfoSection}
  />
)

export default ModelListBlankSlate;
